import { type CatalogPermissionSecondaryCategoryConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'
import { useAssignUsersToSecondaryCategoryPresenter } from './useAssignUsersToSecondaryCategoryPresenter'
import { UserAccessGrid } from '../../views/UserAccessGrid'

export interface IAssignUsersToSecondaryCategoryPresenterProps {
  secondaryCategory: CatalogPermissionSecondaryCategoryConfig
  onSuccess?: () => void
  onCancel?: () => void
}

export const AssignUsersToSecondaryCategoryPresenter = ({
  secondaryCategory,
  onSuccess,
  onCancel,
}: IAssignUsersToSecondaryCategoryPresenterProps) => {
  const { userOptions, isSaving, isLoading, handleSave } =
    useAssignUsersToSecondaryCategoryPresenter({ secondaryCategory, onSuccess })

  return (
    <UserAccessGrid
      secondaryCategory={secondaryCategory}
      userOptions={userOptions}
      isLoading={isLoading}
      isSaving={isSaving}
      onSave={handleSave}
      onCancel={onCancel}
    />
  )
}
